import { ApiFilterResponse } from '@interfaces/filter.types';

const baseURL = process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE;

const filterCache = new Map<string, Promise<ApiFilterResponse | null>>();

export const filterService = {
  getFilters: async (collectionSlug?: string): Promise<ApiFilterResponse | null> => {
    const cacheKey = collectionSlug || 'default';
    
    if (filterCache.has(cacheKey)) {
      return filterCache.get(cacheKey)!;
    }
    
    const apiPromise = (async () => {
      try {
        const queryParams = new URLSearchParams();
        
        if (collectionSlug) {
          const decodedSlug = decodeURIComponent(collectionSlug);
          queryParams.append('slug', decodedSlug);
        }
        
        const apiUrl = `${baseURL}/v1/filters/?${queryParams.toString()}`;

        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        return data;
        
      } catch (error) {
        console.error('Error fetching filter options from API:', error);
        filterCache.delete(cacheKey);
        return null;
      }
    })();

    filterCache.set(cacheKey, apiPromise);

    return apiPromise;
  },

  clearCache: () => {
    filterCache.clear();
  },

  clearCacheEntry: (collectionSlug?: string) => {
    const cacheKey = collectionSlug || 'default';
    filterCache.delete(cacheKey);
  }
}; 